import React, { Fragment } from 'react';
import { Collapse } from 'react-collapse';
import { NavItem } from '@bbkAdminComponents/app-layout/nav/nav-item';
import { determineSelectedNavItem } from '@bbkAdminRedux/app/reducers';
import { useLocation } from '@bbkShared/react-router';
import { BbkNavBarHelper } from '@bbkAdminComponents/app-layout/nav/bbk-navbar-helper';
import { type BBKNavbarOpt } from '@bbkAdminComponents/app-layout/nav/bbk-navbar-opt';

type Props = {
  opts: BBKNavbarOpt[];
  level?: number;
};
export const BbkNavbar: React.FC<Props> = ({
  opts: navbarOptions,
  level = 0,
}) => {
  const location = useLocation();
  const currentPath = determineSelectedNavItem(location.pathname);

  return navbarOptions
    .filter((opt) => opt.show ?? true)
    .map((opt) => {
      const isActive = BbkNavBarHelper.isActive(opt, currentPath);
      return (
        <Fragment key={opt.id}>
          {opt.type === 'header' ? (
            <div className="tw-ml-2.5 tw-pt-3 tw-text-xs tw-text-cbrneutral-400/70">
              {opt.label}
            </div>
          ) : (
            <>
              <NavItem
                subMenu={level > 0}
                highlightBg={opt.highlightBg}
                text={opt.label}
                href={opt.linkTo}
                onClick={opt.onClick}
                trailingIconNode={opt.trailingIcon}
                iconNode={opt.leadingIcon}
                tooltip={opt.tooltip}
                active={isActive}
                disabled={opt.disabled}
                expandChildren={opt.expandChildren}
              />
              {opt.subItems && (
                <Collapse isOpened={Boolean(opt.expandChildren)}>
                  <BbkNavbar opts={opt.subItems} level={level + 1} />
                </Collapse>
              )}
            </>
          )}
        </Fragment>
      );
    });
};
